export interface StaffPortalReadiness {
  isReady: boolean;
  hasConfiguredAiProvider: boolean;
  hasActiveKnowledgeSource: boolean;
  hasActiveTools: boolean;
  toolOnlyUnsupported: boolean;
  missing: string[];
  message: string | null;
}

export interface ChatbotConfigWithReadiness {
  staffPortalReadiness?: StaffPortalReadiness;
}

export const READINESS_UNAVAILABLE_MESSAGE =
  "Staff Portal readiness could not be verified. Please try again or contact an administrator.";

export function getStaffPortalReadiness(
  config: ChatbotConfigWithReadiness | null | undefined,
): StaffPortalReadiness | null {
  const value = config?.staffPortalReadiness;
  if (!value || typeof value.isReady !== "boolean") return null;
  return value;
}

export function getStaffPortalBlockedMessage(
  config: ChatbotConfigWithReadiness | null | undefined,
): string {
  return getStaffPortalReadiness(config)?.message || READINESS_UNAVAILABLE_MESSAGE;
}